import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import reinzLogo from '@/assets/reinz-logo.png'

const MAGIC_LINK_VERIFY_BASE_URL =
  'https://ca-companion-app-playground-v2.niceflower-46f52582.australiaeast.azurecontainerapps.io'

export default function MagicLinkVerify() {
  const [searchParams] = useSearchParams()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    const token = searchParams.get('token')
    if (!token) {
      setStatus('error')
      setMessage('Invalid link. No token found.')
      return
    }

    fetch(`${MAGIC_LINK_VERIFY_BASE_URL}/api/magiclink/verify?token=${encodeURIComponent(token)}`)
      .then((res) => {
        if (res.ok) {
          setStatus('success')
        } else {
          return res.json().then((data) => {
            setStatus('error')
            setMessage(data.error ?? 'This link is invalid or has expired.')
          })
        }
      })
      .catch(() => {
        setStatus('error')
        setMessage('Something went wrong. Please try again.')
      })
  }, [searchParams])

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm text-center space-y-6">
        <img
          src={reinzLogo}
          alt="REINZ"
          className="h-12 w-auto mx-auto bg-black px-4 py-2 rounded"
        />

        {status === 'loading' && (
          <p className="text-muted-foreground text-sm">Verifying your sign-in link…</p>
        )}

        {status === 'success' && (
          <div className="space-y-3">
            <div className="text-5xl text-green-500">✓</div>
            <h1 className="text-xl font-semibold text-foreground">Sign-in verified!</h1>
            <p className="text-sm text-muted-foreground">
              Return to the sign-in page and click <strong>Continue</strong> to complete your login.
            </p>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-3">
            <div className="text-5xl text-red-500">✗</div>
            <h1 className="text-xl font-semibold text-foreground">Link expired</h1>
            <p className="text-sm text-muted-foreground">{message}</p>
            <p className="text-xs text-muted-foreground">
              Please sign in again to receive a new link.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
